import DOMPurify from 'dompurify';

// md-editor-v3 compiles markdown with HTML enabled. The default sanitize
// function returns that HTML unchanged, and the preview writes it with
// innerHTML. DOMPurify removes script and event handlers before the write.
export const sanitizeMarkdownHtml = (html: string): string => DOMPurify.sanitize(html);
